













































































































import Component, { mixins } from 'vue-class-component';
import { loadView, loadWidget } from '@/utils/helpers';
import { namespace } from 'vuex-class';
import { IMerchantBody, IMerchants, IOrganizations, IPaginate } from '@/types/types';
import timestamp from '@/filters/timestamp';
import { Watch } from 'vue-property-decorator';
import WidgetMixins from '@/mixins/WidgetMixins';
import DialogMixins from '@/mixins/DialogMixins';
import qs from 'qs';

const paymentAdminModule = namespace('paymentAdmin');
const organizationModule = namespace('organizations');

@Component({
  name: 'MerchantCredentials',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    EmptyPage: loadWidget('pages/EmptyPage'),
    CreateMerchantDialog: loadView('pages/payments/dialogs/CreateMerchantDialog'),
  },
  filters: { timestamp },
})
export default class MerchantCredentials extends mixins(WidgetMixins, DialogMixins) {
  @paymentAdminModule.Getter('getMerchants') merchants!: IMerchants[];
  @paymentAdminModule.Getter('getMerchantsPagination') pagination!: IPaginate;
  @organizationModule.Getter('getAllOrganizations') organizations!: IOrganizations[];

  options: any = {};
  query: string = '';
  searchTerm: string | null = null;
  private searchTimer?: number;

  headers: Array<{ text: string; value: string; align?: string; sortable?: boolean }> = [
    { text: 'Username', value: 'username' },
    { text: 'Credential ID', value: '_id', sortable: false },
    { text: 'Charges', value: 'additionalCharges', align: 'end' },
    { text: 'Status', value: 'isActive' },
    { text: 'Created', value: 'createdAt' },
  ];

  copy(value: string, label: string): void {
    navigator.clipboard?.writeText(value).then(() => {
      this.$store.dispatch('snackBarMessage', `${label} copied to clipboard`, { root: true });
      this.$store.dispatch('snackBarVisibility', true, { root: true });
    });
  }

  handleSave(body: IMerchantBody): void {
    this.$store.dispatch('paymentAdmin/createMerchant', { body, query: this.query });
  }

  fetchMerchants(): void {
    this.$store.dispatch('paymentAdmin/fetchMerchants', this.query);
  }

  @Watch('searchTerm')
  onSearchTermChange(): void {
    window.clearTimeout(this.searchTimer);
    this.searchTimer = window.setTimeout(() => this.buildQueryAndFetch(1), 400);
  }

  @Watch('options', { deep: true })
  onOptionsChange(paginate: IPaginate): void {
    this.buildQueryAndFetch(paginate.page, paginate.itemsPerPage);
  }

  buildQueryAndFetch(page: number, size?: number): void {
    const query = qs.stringify(
      { page, size: size ?? this.options?.itemsPerPage ?? 30, ...(this.searchTerm && { searchTerm: this.searchTerm }) },
      { skipNulls: true, addQueryPrefix: true },
    );
    if (query === this.query) return;
    this.query = query;
    this.fetchMerchants();
  }

  created(): void {
    this.$store.dispatch('organizations/list', false);
    this.query = qs.stringify({ page: 1, size: 30 }, { addQueryPrefix: true });
    this.fetchMerchants();
  }
}
